import moment from 'moment'
import 'moment/locale/ru'

window.moment = moment

export { moment }
